import { useRouteQuery } from "@vueuse/router";
import {
  ContentRatingEnum,
  MateSearchSorterEnum,
  SearchModeEnum,
  SorterEnum,
} from "@/enums";
import { RatioEnum, TextImageModeEnum } from "@/enums/TextImageEnum";
import { Ref } from "vue";
import { MateType } from "@/enums/mateEnums";

export const searchModeList: {
  title: string;
  value: SearchModeEnum;
  icon: string;
}[] = [
  {
    title: "Moment.character",
    value: SearchModeEnum.CHARACTER,
    icon: "iconify mingcute--user-3-line",
  },
  {
    title: "Cell.image",
    value: SearchModeEnum.IMAGE,
    icon: "iconify mingcute--pic-line",
  },
  {
    title: "Moment.moment",
    value: SearchModeEnum.MOMENT,
    icon: "iconify mingcute--quill-pen-line",
  },
];
export const sorterList: { label: string; value: SorterEnum; icon: string }[] =
  [
    {
      label: "Community.hot",
      value: SorterEnum.HOT,
      icon: "iconify mingcute--fire-line",
    },
    {
      label: "Community.new",
      value: SorterEnum.NEW,
      icon: "iconify mingcute--sort-descending-line",
    },
  ];

export const nsfwFilter: {
  label: string;
  value?: ContentRatingEnum;
  icon?: string;
  isNsfw?: boolean;
}[] = [
  {
    label: "nsfw.noLimit",
    isNsfw: true,
    icon: "iconify mdi--filter-off-outline",
  },
  {
    label: "nsfw.nsfw",
    value: ContentRatingEnum.NSFW,
    icon: "iconify mdi--shield-warning-outline",
    isNsfw: true,
  },
  {
    label: "nsfw.sfw",
    value: ContentRatingEnum.SFW,
    icon: "iconify mingcute--safety-certificate-line",
  },
];
export const mateSorterList: {
  label: string;
  value: MateSearchSorterEnum;
  icon: string;
}[] = [
  {
    label: "Buttons.popular",
    value: MateSearchSorterEnum.POPULAR,
    icon: "iconify mingcute--fire-line",
  },
  {
    label: "Buttons.trending",
    value: MateSearchSorterEnum.TRENDING,
    icon: "iconify mingcute--trending-up-line",
  },
  {
    label: "Community.new",
    value: MateSearchSorterEnum.NEW,
    icon: "iconify mingcute--sort-descending-line",
  },
  {
    label: "Buttons.editorChoice",
    value: MateSearchSorterEnum.Recommended,
    icon: "iconify mingcute--certificate-line",
  },
];

const normalizeNumberArr = (val?: string | string[]) => {
  if (Array.isArray(val)) {
    return val.map((v) => Number(v));
  }
  return val ? [Number(val)] : [];
};
/**
 * 返回中的ref与route.query双向绑定
 */
export const useSearchQuery = () => {
  // TODO 这里没有对每个参数用Enum做过滤
  // SearchType
  const q = useRouteQuery("q", "", { transform: String });
  const type = useRouteQuery("type", SearchModeEnum.CHARACTER, {
    transform: (val) =>
      searchModeList.find((item) => item.value === val)?.value ||
      searchModeList[0].value,
  });
  // ImageSearch
  const model = useRouteQuery("model", [], {
    transform: normalizeNumberArr,
  });
  const ratio = useRouteQuery("ratio", []) as Ref<RatioEnum[]>;
  const mode = useRouteQuery("mode", [], {
    transform: normalizeNumberArr,
  }) as Ref<TextImageModeEnum[]>;
  const creatorType = useRouteQuery("creatorType", []) as Ref<MateType[]>;
  const isNsfw = useRouteQuery("isNsfw", [], {
    transform: normalizeNumberArr,
  }) as Ref<ContentRatingEnum[]>;
  const contentRating = useRouteQuery("contentRating", undefined, {
    transform: (val) => {
      if (!val) return undefined;
      return nsfwFilter.find((item) => item.value === Number(val))?.value;
    },
  }) as Ref<ContentRatingEnum | undefined>;
  const sort = useRouteQuery(
    "sort",
    type.value === SearchModeEnum.CHARACTER
      ? MateSearchSorterEnum.POPULAR
      : SorterEnum.HOT
  ) as Ref<SorterEnum | MateSearchSorterEnum>;
  const isAll = useRouteQuery("isAll", 0, {
    transform: Number,
  }) as Ref<0 | 1>;

  const toggle = <T>(ref: Ref<T[]>, value: T) => {
    const index = ref.value.indexOf(value);
    if (index === -1) {
      ref.value = [...ref.value, value];
    } else {
      ref.value = ref.value.filter((item) => item !== value);
    }
  };

  return {
    // Search Common
    q,
    type,
    sort,
    // ImageSearch Only
    model,
    ratio,
    mode,
    creatorType,
    isNsfw,
    // CharacterSearchOnly
    isAll,
    mateSorterList,
    contentRating,
    // Methode
    toggle,
  };
};
